import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { Observable } from 'rxjs';
import { config } from '../config';
import { UtilityService } from './utility.service';


@Injectable({
  providedIn: 'root'
})
export class S3UploadService {

  constructor(
    public _utilityService: UtilityService
  ) { }

  uploadFile(file, filename) {
    console.log('File and File Name', file, filename);

    const contentType = file.type;
    let re = /(?:\.([^.]+))?$/;
    let ext = re.exec(file.name)[1];
    let name = file.name.split('.').slice(0, -1).join('.')
    let newName = name + '-' + Date.now() + '.' + ext;

    const bucket = new S3(
      {
        // accessKeyId: config.key,
        accessKeyId: this._utilityService.getAwsCredential('key'),
        // secretAccessKey: config.secret,
        secretAccessKey: this._utilityService.getAwsCredential('seceret'),
        region: config.region
      }
    );
    const params = {
      Bucket: config.bucket,
      Key: newName,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType,
      ContentEncoding: 'base64',
      ContentDisposition: 'attachment',
      metadata: { 'contentType': contentType }
      // metadata
    };
    //for upload progress   
    return new Observable<any>((observer) => {
      bucket.upload(params).on('httpUploadProgress', function (evt) {
        console.log('Event In evt====>>>>', evt);
        observer.next(evt);
      }).send(function (err, data) {
        if (err) {
          console.log('There was an error uploading your file: ', err);
          observer.error(err);
        }
        console.log('Successfully uploaded file.', data);
        observer.next(data);
      });
    })
  }


  uploadSignature(file) {
    console.log('File and File Name', file);

    const contentType = file.type;
    let re = /(?:\.([^.]+))?$/;
    let ext = re.exec(file.name)[1];
    let name = file.name.split('.').slice(0, -1).join('.')
    let newName = name + '-' + Date.now() + '.' + ext;

    const bucket = new S3(
      {
        accessKeyId: '',
        secretAccessKey: '',
        region: 'ap-south-1'
      }
    );
    const params = {
      Bucket: 'testing-platinum-rail-services',
      Key: "signature/" + newName,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType,
      ContentEncoding: 'base64',
      ContentDisposition: 'attachment',
    };
    return new Observable<any>((observer) => {
      bucket.upload(params, function (evt) {
        console.log('Event In evt====>>>>', evt);
        observer.next(evt);
      }).send(function (err, data) {
        if (err) {
          console.log('There was an error uploading your file: ', err);
          observer.error(err);
        }
        console.log('Successfully uploaded file.', data);
        observer.next(data);
      });
    })
  }


  uploadSignatureBase64(base64) {
    console.log('File and File Name', base64);

    let newName = 'sign' + '-' + Date.now();


    let byteString = atob(base64.split(',')[1]);
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    let blob = new Blob([ia], { type: 'image/png' });
    console.log("blob====>", blob);
    blob['name'] = newName


    const bucket = new S3(
      {
        // accessKeyId: config.key,
        accessKeyId: this._utilityService.getAwsCredential('key'),
        // secretAccessKey: config.secret,
        secretAccessKey: this._utilityService.getAwsCredential('seceret'),
        region: config.region
      }
    );
    const params = {
      Bucket: config.bucket,
      Key: "signature/" + newName,
      Body: blob,
      ACL: 'public-read',
      ContentType: 'image/png',
      ContentEncoding: 'base64',
      ContentDisposition: 'attachment',
    };
    return new Observable<any>((observer) => {
      bucket.upload(params, function (evt) {
        observer.next(evt);
      }).send(function (err, data) {
        if (err) {
          observer.error(err);
        }
        console.log('Successfully uploaded file.', data);
        observer.next(data);
      });
    })
  }

}